import { render, staticRenderFns } from "./costView.vue?vue&type=template&id=4450e6e4&scoped=true&"
import script from "./costView.vue?vue&type=script&lang=js&"
export * from "./costView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4450e6e4",
  null
  
)

export default component.exports